<template>
  <div class="q-sort-bar d-flex flex-wrap align-items-center gap-2 mb-4">

    <div class="d-flex align-items-center gap-2">
      <label class="q-sort-label">Por página</label>
      <select class="form-select form-select-sm q-sort-select" v-model="itemCount" @change="changeQuantity">
        <option value="8">8</option>
        <option value="16">16</option>
        <option value="24">24</option>
      </select>
    </div>

    <div class="d-flex align-items-center gap-2">
      <label class="q-sort-label">Ordenar por</label>
      <select class="form-select form-select-sm q-sort-select" v-model="sortMethod" @change="changeSortMethod">
        <option value="abc">A → Z</option>
        <option value="zwy">Z → A</option>
        <option value="new">Más nuevos</option>
        <option value="old">Más antiguos</option>
        <option v-show="showPrice" value="minmax">Menor precio</option>
        <option v-show="showPrice" value="maxmin">Mayor precio</option>
        <option v-show="showPrice && configuration.show_pricelists == 1" value="MinMax">Menor precio (May)</option>
        <option v-show="showPrice && configuration.show_pricelists == 1" value="MaxMin">Mayor precio (May)</option>
      </select>
    </div>

    <div class="q-view-toggle ms-auto">
      <button
        type="button"
        :class="['q-view-btn', { 'q-view-btn--active': currentView === 'grid' }]"
        @click="setView('grid')"
        title="Vista cuadrícula"
      >
        <i class="bi bi-grid-3x3-gap-fill"></i>
      </button>
      <button
        type="button"
        :class="['q-view-btn', { 'q-view-btn--active': currentView === 'list' }]"
        @click="setView('list')"
        title="Vista lista"
      >
        <i class="bi bi-list-ul"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueScrollTo from "vue-scrollto";

export default {
  name: "ShopSortControl",
  props: ["productsOnPages", "defaultSortMethod"],
  data() {
    return { itemCount: "8", sortMethod: "abc", currentView: "grid" };
  },
  mounted() {
    this.itemCount  = this.productsOnPages;
    this.sortMethod = this.defaultSortMethod;
  },
  computed: {
    ...mapGetters({
      user:          "ecommerce/user",
      configuration: "ecommerce/configuration",
    }),
    showPrice() {
      return this.configuration.show_public_prices || this.user != null;
    },
  },
  methods: {
    changeQuantity()   { this.$emit("changeQuantity", parseInt(this.itemCount)); },
    changeSortMethod() { this.$emit("changeSortMethod", this.sortMethod); },
    scrollToSection()  { VueScrollTo.scrollTo("#widgetFiltros", 300, { offset: -100 }); },
    setView(mode)      { this.currentView = mode; this.$emit("changeView", mode); },
  },
};
</script>

<style scoped>
.q-sort-bar {
  border-bottom: 1px solid var(--q-border);
  padding-bottom: 16px;
}
.q-sort-label {
  font-family: var(--q-font-display);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--q-text-subtle);
  white-space: nowrap;
  margin: 0;
}
.q-sort-select {
  width: auto;
  min-width: 130px;
  background-color: var(--q-bg-elevated);
  border-color: var(--q-border);
  color: var(--q-text);
  font-size: 12px;
}
.q-sort-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(0,212,255,0.1);
}
.q-filter-mobile-btn {
  border-color: var(--q-border);
  color: var(--q-text-muted);
  font-family: var(--q-font-display);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.q-view-toggle {
  display: flex;
  gap: 4px;
}
.q-view-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--q-bg-elevated);
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius);
  color: var(--q-text-subtle);
  font-size: 14px;
  cursor: pointer;
  transition: all var(--q-transition);
}
.q-view-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.q-view-btn--active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
</style>
